import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    competence_types: [],
    competence_types_url: '/mesh/competence-type'
}

const getters = {
    [names.COMPETENCE_TYPES]: state => {
        if (!get.store.state.user) return [];
        return state.competence_types.filter((x) => x.school == get.store.state.user.school).sort(function(a, b) {
            if (a.order > b.order) return 1;
            if (a.order < b.order) return -1;
            return 0;
        });
    },
}

const mutations = {
    [names.MUTATE_COMPETENCE_TYPES]: (state, competence_types) => {
        competence_types.forEach(element => {
            let index = state.competence_types.findIndex(x => x.id == element.id);
            if (index != -1) state.competence_types.splice(index, 1, element);
            else state.competence_types.push(element);
        });
    },
    [names.MUTATE_COMPETENCE_TYPE]: (state, competence_type) => {
        let index = state.competence_types.findIndex(x => x.id == competence_type.id);
        if (index != -1) state.competence_types.splice(index, 1, competence_type);
        else state.competence_types.push(competence_type);
    },
    [names.MUTATE_DELETE_COMPETENCE_TYPE]: (state, competence_type_id) => {
        let index = state.competence_types.findIndex(x => x.id == competence_type_id);
        if (index != -1) state.competence_types.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_COMPETENCE_TYPE]: ({
        commit,
        state
    }, competence_type_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.competence_types_url}/${competence_type_id}/`)
                .then(response => {
                    commit(names.MUTATE_COMPETENCE_TYPE, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_COMPETENCE_TYPES]: ({
        commit,
        state,
    }, ) => {
        return new Promise((resolve) => {
            restful.GetAll(`${state.competence_types_url}/`)
                .then(response => {
                    commit(names.MUTATE_COMPETENCE_TYPES, response);
                    resolve(response);
                });
        });
    },
    [names.POST_COMPETENCE_TYPE]: ({
        commit,
        state
    }, competence_type) => {
        return new Promise((resolve) => {
            restful.Post(`${state.competence_types_url}/`, competence_type)
                .then(response => {
                    commit(names.MUTATE_COMPETENCE_TYPE, response);
                    resolve(response);
                });
        });
    },
    [names.UPDATE_COMPETENCE_TYPE]: ({
        commit,
        state
    }, competence_type) => {
        return new Promise((resolve) => {
            restful.Put(`${state.competence_types_url}/${competence_type.id}/`, competence_type)
                .then(response => {
                    commit(names.MUTATE_COMPETENCE_TYPE, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_COMPETENCE_TYPE]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.competence_types_url}/${payload.competence_type_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_COMPETENCE_TYPE, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_COMPETENCE_TYPE]: ({
        commit,
        state
    }, competence_type_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.competence_types_url}/${competence_type_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_COMPETENCE_TYPE, competence_type_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};